import React from 'react';
import PropTypes from 'prop-types';
import { RemainingText } from './styles';

const TextRemaingCategories = (props) => {
  const {
    mappedGroups,
    showRemaining,
  } = props;

  const handleAccordionMessage = () => {
    if (!showRemaining) {
      return (mappedGroups.remainingGroups.length === 1) ? 'View 1 more category' : `View ${mappedGroups.remaining} more categories`;
    }
    return (mappedGroups.remainingGroups.length === 1) ? 'Hide category' : 'Hide categories';
  };

  const accordionMessage = handleAccordionMessage();

  return (
    <RemainingText>
      {accordionMessage}
    </RemainingText>
  );
};

TextRemaingCategories.propTypes = {
  mappedGroups: PropTypes.shape({
    remainingGroups: PropTypes.array,
    remaining: PropTypes.number,
  }).isRequired,
  showRemaining: PropTypes.bool.isRequired,
};

export default TextRemaingCategories;
